import { MdCancel, MdOutlinePhotoCamera } from "react-icons/md";

const IdentityForm = ({ formik }) => {
  return (
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 items-center">
      <div className="w-full">
        <p className="mb-2">Unggah foto KTP Anda</p>
        {formik.values.ktp ? (
          <div className=" h-[150px] flex flex-col items-center justify-center w-[100%] p-6 bg-[#F7F8F9] border-2 border-[#071B82] border-dashed rounded-lg">
            <div className="relative">
              <img
                src={URL.createObjectURL(formik.values.ktp)}
                className="w-[100px] h-[100px] object-cover z-10 rounded-md"
              />
              <MdCancel
                className="text-[#ffffff] cursor-pointer hover:text-red-500 text-[24px] z-20 absolute top-1 right-1"
                onClick={() => formik.setFieldValue("ktp", null)}
              />
            </div>
          </div>
        ) : (
          <div>
            <label
              htmlFor="dropzone-file1"
              className="h-[150px] cursor-pointer flex flex-col items-center justify-center w-[100%] p-6 bg-[#F7F8F9] border-2 border-[#071B82] border-dashed rounded-lg"
            >
              <div>
                <input
                  id="dropzone-file1"
                  hidden
                  type="file"
                  accept="image/jpeg, image/png, image/jpg"
                  onChange={(e) =>
                    formik.setFieldValue("ktp", e.target.files[0])
                  }
                />
                <div className="flex justify-center items-center text-center gap-2">
                  <MdOutlinePhotoCamera className="text-[20px]" />
                  <p className="text-[14px] font-semibold">Unggah di sini</p>
                </div>
              </div>
            </label>
          </div>
        )}
        <p>Format .jpeg, .jpg, .png</p>
      </div>
      <div className="w-full">
        <p className="mb-2 whitespace-nowrap truncate">
          Unggah swafoto sambil memegang KTP
        </p>
        {formik.values.selfie ? (
          <div className=" h-[150px] flex flex-col items-center justify-center w-[100%] p-6 bg-[#F7F8F9] border-2 border-[#071B82] border-dashed rounded-lg">
            <div className="relative">
              <img
                src={URL.createObjectURL(formik.values.selfie)}
                className="w-[100px] h-[100px] object-cover z-10 rounded-md"
              />
              <MdCancel
                className="text-[#ffffff] cursor-pointer hover:text-red-500 text-[24px] z-20 absolute top-1 right-1"
                onClick={() => formik.setFieldValue("selfie", null)}
              />
            </div>
          </div>
        ) : (
          <div>
            <label
              htmlFor="dropzone-file2"
              className="h-[150px] cursor-pointer flex flex-col items-center justify-center w-[100%] p-6 bg-[#F7F8F9] border-2 border-[#071B82] border-dashed rounded-lg"
            >
              <div>
                <input
                  id="dropzone-file2"
                  hidden
                  type="file"
                  accept="image/jpeg, image/png, image/jpg"
                  onChange={(e) =>
                    formik.setFieldValue("selfie", e.target.files[0])
                  }
                />
                <div className="flex justify-center items-center text-center gap-2">
                  <MdOutlinePhotoCamera className="text-[20px]" />
                  <p className="text-[14px] font-semibold">Unggah di sini</p>
                </div>
              </div>
            </label>
          </div>
        )}
        <p>Format .jpeg, .jpg, .png</p>
      </div>
    </div>
  );
};

export default IdentityForm;
